<template>
  <v-layout justify-center>
    <v-flex xs12 lg10 mb-5>
      <v-layout row wrap pl-2 pr-2>
        <v-flex xs12 sm3 offset-sm9>
          <v-text-field
            v-model="search"
            label="Search Elections"
            prepend-icon="search"
            v-on:keyup="searchElections"
            clearable
            @click:clear="clearMessage"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-card>
        <v-progress-circular
           v-show="loading"
          :size="50"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
        <v-list
          :max-height=this.height
          class="scroll-y"
          three-line
        >
          <template v-for="(employee, index) in showElections">
            <v-list-tile
              :key="index"
            >
              <v-list-tile-content>
                <v-list-tile-title v-text="employee.name"></v-list-tile-title>
                <v-list-tile-sub-title><strong>Start Date:</strong> {{ employee.displayStartDate }} <strong>End Date:</strong> {{ employee.displayEndDate }}</v-list-tile-sub-title>
                <v-list-tile-sub-title><strong>Notes:</strong> {{ employee.notes }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-menu bottom offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      icon
                      small
                      color="blue"
                      dark
                      v-on="on"
                    >
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-subheader>SELECT OPTION</v-subheader>

                    <v-list-tile @click="editItem(employee.id)">
                      <v-list-tile-avatar>
                        <v-icon color="primary">edit</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        Edit
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile @click="editVoter(employee.id)">
                      <v-list-tile-avatar>
                        <v-icon color="primary">list</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        List Voters
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile @click="editTotal(employee.id)">
                      <v-list-tile-avatar>
                        <v-icon color="primary">check</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        Finalize Vote
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider v-if="index + 1 < showElections.length" :key="`divider-${index}`"></v-divider>
          </template>
        </v-list>
      </v-card>
    </v-flex>

    <v-btn
      v-if="isAdmin"
      fab
      bottom
      right
      color="blue"
      dark
      fixed
      class="add-button-bottom"
      @click.stop="newItem"
    >
      <v-icon>add</v-icon>
    </v-btn>

    <v-dialog
      v-model="dialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="closeDialog">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Election</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn v-if="edit" dark flat @click="updateItem">Update</v-btn>
            <v-btn v-else dark flat @click="addItem">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-layout class="pb-3" row wrap>
            <v-flex xs12>
              <v-text-field
                v-model="editElection.name"
                label="Election Name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm3>
              <v-menu
                ref="menu1"
                :close-on-content-click="false"
                v-model="menu1"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="editElection.startDate"
                  label="Start Date"
                  @blur="date = parseDate(editElection.startDate)"
                ></v-text-field>
                <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm3 offset-sm1>
              <v-menu
                ref="menu1"
                :close-on-content-click="false"
                v-model="menu2"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="editElection.endDate"
                  label="End Date"
                  @blur="date2 = parseDate(editElection.endDate)"
                ></v-text-field>
                <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm4 offset-sm1>
              <v-text-field
                v-if="!edit"
                v-model="editElection.password"
                label="Password"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm3>
              <v-text-field
                v-model="editElection.numberDirectors"
                label="# Directors"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 offset-sm1>
              <v-text-field
                v-model="editElection.numberExecs"
                label="# Exec Committee"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm3 offset-sm1>
              <v-select
                v-model="editElection.status"
                :items="items"
                label="Select Status"
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                v-model="editElection.notes"
                label="Notes"
                counter
                maxlength="255"
              ></v-textarea>
            </v-flex>
          </v-layout>
         <v-divider></v-divider>
          <v-list three-line subheader>
            <v-subheader>Candidates</v-subheader>
            <template v-for="(person, index) in candidateList">
            <v-list-tile :key="index" avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ person.position }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ person.name }}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn
                  small
                  fab
                  icon
                  color="red"
                  dark
                  @click="removeCandidate(person.id)"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            </template>
            <v-divider></v-divider>
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-layout>
                  <v-flex xs4>
                    <v-select
                      v-model="editPerson.position"
                      :items="positions"
                      label="Select Position"
                    ></v-select>
                  </v-flex>
                  <v-flex xs5>
                    <v-combobox
                      v-model="editPerson.userId"
                      :items="rows"
                      item-text="fullName"
                      item-value="id"
                      label="Select Candidate"
                    ></v-combobox>
                  </v-flex>
                  <v-flex xs3>
                    <v-checkbox
                      v-model="incumbent"
                      label="Incumbent"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn
                  small
                  fab
                  icon
                  color="blue"
                  dark
                  @click="addCandidate()"
                >
                  <v-icon>add</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog1"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="closeDialog">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Voters</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
      <v-card>
        <v-progress-circular
          v-show="loading"
          :size="50"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
        <v-list
          style="max-height: 500px"
          class="scroll-y"
          three-line
        >
          <template v-for="(voter, index) in voters">
            <v-list-tile
              :key="index"
            >
              <v-list-tile-content>
                <v-list-tile-title v-text="voter.fullName"></v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <span v-if="voter.voted">Voted</span>
                <v-btn
                  v-else
                  fab
                  icon
                  small
                  color="blue"
                  dark
                  @click="printVoter(voter.id)"
                >
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider v-if="index + 1 < voters.length" :key="`divider-${index}`"></v-divider>
          </template>
        </v-list>
      </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog2"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="800px"
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card v-if="!goodPassword">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs10>
              <v-text-field
                v-model="password"
                label="Password"
              ></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-btn
                small
                color="blue"
                dark
                @click="getVotes()"
              >
                Submit
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-card v-else tile>
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="closeDialog">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Election</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="printFinal()">Print <v-icon>mdi-printer</v-icon></v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm8>
              <v-layout class="pb-3" row wrap>
                <v-flex xs12>
                  Election Name: <strong>{{ editElection.name }}</strong>
                </v-flex>
                <v-flex xs12 sm3>
                  Start Date: {{ editElection.startDate }}
                </v-flex>
                <v-flex xs12 sm3>
                  End Date: {{ editElection.endDate }}
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    v-if="!edit"
                    v-model="editElection.password"
                    label="Password"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  # Directors: {{ editElection.numberDirectors }}
                </v-flex>
                <v-flex xs12 sm4 >
                  # Exec Comm: {{ editElection.numberExecs }}
                </v-flex>
                <v-flex xs12 sm3>
                  <v-select
                    v-model="editElection.status"
                    :items="items"
                    label="Select Status"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  Notes: {{ editElection.notes }}
                </v-flex>
              </v-layout>

              <v-divider></v-divider>

              <v-list
                style="max-height: 300px"
                class="scroll-y"
                two-line
              >
                <template v-for="(person, index) in candidateList">
                  <v-list-tile :key="index" avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ person.name }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{ person.position }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-content>
                      {{ person.count }} + {{ person.manual }} = {{ person.total }}
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-btn
                        fab
                        icon
                        small
                        color="blue"
                        dark
                        @click="addVote(index)"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-action>
                      <v-btn
                        fab
                        icon
                        small
                        color="red"
                        dark
                        @click="subVote(index)"
                      >
                        <v-icon>mdi-minus</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                </template>
              </v-list>
            </v-flex>

            <v-flex xs12 sm4>
              <v-card>
                <v-list
                  style="max-height: 500px"
                  class="scroll-y"
                  three-line
                >
                  <template v-for="(voter, index) in voters">
                    <v-list-tile
                      :key="index"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title v-text="voter.fullName"></v-list-tile-title>
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <span v-if="voter.voted">Voted</span>
                        <span v-else>Did not Vote</span>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider v-if="index + 1 < voters.length" :key="`divider-${index}`"></v-divider>
                  </template>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
// import jsPDF from 'jspdf'
let pdfMake = require('pdfmake/build/pdfmake.js')
let pdfFonts = require('pdfmake/build/vfs_fonts.js')
pdfMake.vfs = pdfFonts.pdfMake.vfs

export default {
  name: 'elections',

  data: () => ({
    height: 0,
    loading: false,
    isAdmin: false,
    date: null,
    menu1: false,
    date2: null,
    menu2: false,
    dialog: false,
    dialog1: false,
    dialog2: false,
    edit: false,
    incumbent: false,
    electionId: 0,
    logo: '',
    box: '',
    snackbar: {
      show: false,
      color: '',
      message: ''
    },
    loaded: false,
    search: '',
    elections: [],
    voters: [],
    showElections: [],
    rows: [],
    items: ['Pending', 'Active', 'Closed'],
    positions: ['2nd Vice President', 'Treasurer', 'Secretary', 'Exec Committee', 'Director', 'Past President'],
    editElection: {
      id: '',
      name: '',
      startDate: '',
      endDate: '',
      status: '',
      notes: '',
      numberDirectors: 0,
      numberExecs: 0,
      password: ''
    },
    defaultElection: {
      id: '',
      name: '',
      startDate: '',
      endDate: '',
      status: '',
      notes: '',
      numberDirectors: 0,
      numberExecs: 0,
      password: ''
    },
    editPerson: {
      id: '',
      position: '',
      userId: ''
    },
    defaultPerson: {
      id: '',
      position: '',
      userId: ''
    },
    candidateList: [],
    password: '',
    goodPassword: false,
    theVotes: {}
  }),

  created () {
    this.loaded = true

    if (this.$store.state.isAdmin) {
      this.isAdmin = true
    } else {
      this.isAdmin = this.$store.state.controls.includes('Users')
    }

    this.getItems()
    this.getElections()
    this.getLogo()

    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  watch: {
    date (val) {
      this.editElection.startDate = this.formatDate(this.date)
    },
    date2 (val) {
      this.editElection.endDate = this.formatDate(this.date2)
    }
  },

  methods: {
    async getLogo () {
      const response = await Api().get('get_logo')
      this.logo = response.data

      const response1 = await Api().get('get_box')
      this.box = response1.data
      console.log(this.box)
    },

    handleResize () {
      const height = window.innerHeight - 300
      this.height = height + 'px'
    },

    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },

    closeDialog () {
      this.candidateList = []
      this.editElection = this.defaultElection
      this.dialog = false
      this.dialog1 = false
      this.dialog2 = false
      this.goodPassword = false
      this.edit = false
    },

    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    download () {
      let docDefinition = {
        footer: function (currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount },
        content: [
          // basic usage
          { qr: 'text in QR' },

          {
            layout: 'lightHorizontalLines', // optional
            table: {
              // headers are automatically repeated if the table spans over multiple pages
              // you can declare how many rows should be treated as headers
              headerRows: 1,
              widths: [ '*', 'auto', 100, '*' ],

              body: [
                [ 'First', 'Second', 'Third', 'The last one' ],
                [ 'Value 1', 'Value 2', 'Value 3', 'Value 4' ],
                [ { text: 'Bold value', bold: true }, 'Val 2', 'Val 3', 'Val 4' ]
              ]
            }
          }
        ]
      }

      pdfMake.createPdf(docDefinition).download('optionalName.pdf')
    },

    // Get election information for display and reports
    async getElections () {
      try {
        const response = await Api().get('elections')

        const elections = response.data

        let row = {}
        const rows = []

        for (let i in elections) {
          row['id'] = elections[i].id
          row['name'] = elections[i].name
          row['startDate'] = elections[i].startDate
          row['endDate'] = elections[i].endDate
          row['displayStartDate'] = this.formatDate(elections[i].startDate)
          row['displayEndDate'] = this.formatDate(elections[i].endDate)
          row['notes'] = elections[i].notes

          rows.push(row)
          row = {}
        }

        this.elections = rows
        this.showElections = rows
        this.loading = false
      } catch (e) {
        console.error(e)
      }
    },

    async getItems () {
      let allUsers = 'users'

      try {
        const response = await Api().get(allUsers)
        const members = response.data
        // let member = {}

        for (let i in members) {
          if (members[i].TitleId === 1 || members[i].TitleId === 2 || members[i].TitleId === 3) {
            // member.id = members[i].id
            // member.name = members[i].fullName

            this.rows.push(members[i])
          }
        }
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getVoters (id) {
      console.log(id)
      try {
        const response = await Api().get('users_by_title/Director-Past President')
        const voters = response.data
        console.log('voters', voters)

        this.voters = voters

        for (let i in voters) {
          let electionVoters = voters[i].ElectionVoters

          if (electionVoters.length > 0) {
            for (let j in electionVoters) {
              if (electionVoters[j].ElectionMainId === id) {
                console.log(voters[i].fullName, electionVoters[j].ElectionMainId)
                voters[i].voted = 'Yes'
              }
            }
          }
        }
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getVotes () {
      let body = {}
      let data = {}

      data.password = this.password
      data.ElectionMainId = this.editElection.id
      body.form = data

      try {
        const response = await Api().get('votes/' + this.editElection.id + '/' + this.password)
        this.theVotes = response.data
        this.goodPassword = true

        let vote = {}
        let votes = []

        for (let i in this.theVotes) {
          for (let j in this.theVotes[i]) {
            vote.position = this.theVotes[i][j].position
            vote.userId = this.theVotes[i][j].userId
            vote.name = this.theVotes[i][j].name
            votes.push(vote)
            vote = {}
          }
        }

        for (let i in this.candidateList) {
          const count = votes.filter((obj) => obj.userId === this.candidateList[i].userId && obj.position === this.candidateList[i].position).length
          this.candidateList[i].count = count
          this.candidateList[i].manual = 0
          this.candidateList[i].total = count

          // console.log(this.candidateList[i].userId, this.candidateList[i].name, count)
        }
        console.log(votes)

        this.password = ''
      } catch (error) {
        this.password = ''
        this.goodPassword = false
        this.snackbar.message = 'Invalid password!'
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async addItem () {
      let body = {}
      body.form = this.editElection
      body.list = this.candidateList
      console.log(this.editElection)

      try {
        const response = await Api().post('addElection', body)
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
        this.showElections.push(this.editElection)
        this.editElection = this.defaultElection
        this.dialog = false
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateItem () {
      delete this.editElection.password

      let body = {}
      body.form = this.editElection
      body.list = this.candidateList
      console.log(this.editElection)

      try {
        const response = await Api().put('elections/' + this.editElection.id, body)
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
        this.editElection = this.defaultElection
        this.dialog = false
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async editItem (id) {
      try {
        const response = await Api().get('elections/' + id)

        // this.voters = response.data.ElectionVoters
        // console.log(response.data)

        this.editElection.id = response.data.id
        this.editElection.name = response.data.name
        this.editElection.startDate = this.formatDate(response.data.startDate)
        this.editElection.endDate = this.formatDate(response.data.endDate)
        this.editElection.status = response.data.status
        this.editElection.notes = response.data.notes
        this.editElection.numberDirectors = response.data.numberDirectors
        this.editElection.numberExecs = response.data.numberExecs

        this.candidateList = response.data.ElectionCandidates

        this.dialog = true
        this.edit = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async editVoter (id) {
      try {
        this.electionId = id

        this.getVoters(id)

        this.dialog1 = true
        // this.edit = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async editTotal (id) {
      try {
        this.electionId = id

        this.getVoters(id)

        const response = await Api().get('elections/' + id)

        // this.voters = response.data.ElectionVoters
        // console.log(response.data)

        this.editElection.id = response.data.id
        this.editElection.name = response.data.name
        this.editElection.startDate = this.formatDate(response.data.startDate)
        this.editElection.endDate = this.formatDate(response.data.endDate)
        this.editElection.status = response.data.status
        this.editElection.notes = response.data.notes
        this.editElection.numberDirectors = response.data.numberDirectors
        this.editElection.numberExecs = response.data.numberExecs

        this.candidateList = response.data.ElectionCandidates
        this.dialog2 = true
        // this.edit = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async addCandidate () {
      try {
        let response = {}
        let candidate = {}
        let incumbent = ''

        if (this.incumbent) {
          incumbent = ' (Incumbent)'
        }

        candidate.id = this.editPerson.userId.id
        candidate.name = this.editPerson.userId.fullName + incumbent
        candidate.position = this.editPerson.position

        this.candidateList.push(candidate)

        if (this.edit) {
          candidate = {}
          candidate.userId = this.editPerson.userId.id
          candidate.ElectionMainId = this.editElection.id
          candidate.name = this.editPerson.userId.fullName + incumbent
          candidate.position = this.editPerson.position
          console.log('edit', candidate)

          response = await Api().post('add_candidate', candidate)
        }

        this.editPerson = this.defaultPerson
        this.incumbent = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    removeCandidate (index) {
      // console.log('remove candidate', index)

      let candidateList = this._.remove(this.candidateList, function (e) {
        return e.id !== index
      })

      this.candidateList = candidateList
      // console.log('test', candidateList)
    },

    addVote (index) {
      let candidate = this.candidateList[index]

      candidate.manual += 1
      candidate.total += 1

      this.candidateList.splice(index, 1, candidate)
    },

    subVote (index) {
      let candidate = this.candidateList[index]

      candidate.manual -= 1
      candidate.total -= 1

      this.candidateList.splice(index, 1, candidate)
    },

    newItem () {
      this.dialog = true
    },

    clearMessage () {
      this.search = ''
      this.showElections = this.elections
    },

    searchElections () {
      if (this.search) {
        let search = this.search.toLowerCase()
        this.team = 'All'

        let elections = this._.filter(this.elections, function (obj) {
          if (obj.name.toLowerCase().indexOf(search) !== -1) {
            return obj.name.toLowerCase().indexOf(search) !== -1
          }

          if (obj.category.toLowerCase().indexOf(search) !== -1) {
            return obj.category.toLowerCase().indexOf(search) !== -1
          }
        })

        this.showElections = elections
      } else {
        this.showElections = this.elections
      }
    },

    async printVoter (id) {
      try {
        await Api().post('print_voter/' + id + '/' + this.electionId)

        const response = await Api().get('elections/' + this.electionId)

        const electionName = response.data.name
        const numberDirectors = response.data.numberDirectors
        const numberExecs = response.data.numberExecs
        const candidateList = response.data.ElectionCandidates
        const director = []
        const execComm = []
        const secvp = []
        const treasurer = []
        const secretary = []
        const pastpres = []

        for (let i = 0; i < candidateList.length; i++) {
          console.log(candidateList[i])

          if (candidateList[i].position === 'Director') {
            director.push(candidateList[i])
          }

          if (candidateList[i].position === 'Exec Committee') {
            execComm.push(candidateList[i])
          }

          if (candidateList[i].position === '2nd Vice President') {
            secvp.push(candidateList[i])
          }

          if (candidateList[i].position === 'Treasurer') {
            treasurer.push(candidateList[i])
          }

          if (candidateList[i].position === 'Secretary') {
            secretary.push(candidateList[i])
          }

          if (candidateList[i].position === 'Past President') {
            pastpres.push(candidateList[i])
          }
        }

        let docDefinition = {
          // footer: function (currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount },
          content: [
            {
              image: 'data:image/jpeg;base64,' + this.logo,
              width: 100,
              alignment: 'center'
            },

            { text: electionName + ' Election', style: 'header' }
          ],

          styles: {
            header: {
              fontSize: 10,
              bold: true,
              alignment: 'center',
              margin: [ 0, 0, 0, 3 ]
            }
          }
        }

        if (director.length > 0) {
          let directors = {
            text: 'DIRECTOR Ckeck up to ' + numberDirectors + ' candidate(s)',
            alignment: 'left',
            fontSize: 9,
            bold: true,
            margin: [ 0, 10, 0, 0 ]
          }
          docDefinition.content.push(directors)

          for (let j in director) {
            let name = { columns: [ { image: 'data:image/jpeg;base64,' + this.box, width: 12 }, { text: director[j].name, fontSize: 9, alignment: 'left', margin: [ 20, 0, 0, 0 ] } ], margin: [ 0, 7, 0, 0 ] }
            docDefinition.content.push(name)
          }
        }

        if (execComm.length > 0) {
          let titleExec = {
            text: 'EXEC COMMITTEE Ckeck up to ' + numberExecs + ' candidate(s)',
            alignment: 'left',
            fontSize: 9,
            bold: true,
            margin: [ 0, 11, 0, 0 ]
          }
          docDefinition.content.push(titleExec)

          for (let k in execComm) {
            let name = { columns: [ { image: 'data:image/jpeg;base64,' + this.box, width: 12 }, { text: execComm[k].name, fontSize: 9, alignment: 'left', margin: [ 20, 0, 0, 0 ] } ], margin: [ 0, 7, 0, 0 ] }
            docDefinition.content.push(name)
          }
        }

        if (secvp.length > 0) {
          let titlesecvp = {
            text: '2nd Vice President Ckeck 1 candidate',
            alignment: 'left',
            fontSize: 9,
            bold: true,
            margin: [ 0, 11, 0, 0 ]
          }
          docDefinition.content.push(titlesecvp)

          for (let k in secvp) {
            let name = { columns: [ { image: 'data:image/jpeg;base64,' + this.box, width: 12 }, { text: secvp[k].name, fontSize: 9, alignment: 'left', margin: [ 20, 0, 0, 0 ] } ], margin: [ 0, 7, 0, 0 ] }
            docDefinition.content.push(name)
          }
        }

        if (treasurer.length > 0) {
          let titletreasurer = {
            text: 'Treasurer Ckeck 1 candidate',
            alignment: 'left',
            fontSize: 9,
            bold: true,
            margin: [ 0, 11, 0, 0 ]
          }
          docDefinition.content.push(titletreasurer)

          for (let k in treasurer) {
            let name = { columns: [ { image: 'data:image/jpeg;base64,' + this.box, width: 12 }, { text: treasurer[k].name, fontSize: 9, alignment: 'left', margin: [ 20, 0, 0, 0 ] } ], margin: [ 0, 7, 0, 0 ] }
            docDefinition.content.push(name)
          }
        }

        if (secretary.length > 0) {
          let titlesecretary = {
            text: 'Secretary Ckeck 1 candidate',
            alignment: 'left',
            fontSize: 9,
            bold: true,
            margin: [ 0, 11, 0, 0 ]
          }
          docDefinition.content.push(titlesecretary)

          for (let k in secretary) {
            let name = { columns: [ { image: 'data:image/jpeg;base64,' + this.box, width: 12 }, { text: secretary[k].name, fontSize: 9, alignment: 'left', margin: [ 20, 0, 0, 0 ] } ], margin: [ 0, 7, 0, 0 ] }
            docDefinition.content.push(name)
          }
        }

        if (pastpres.length > 0) {
          let titlepastpres = {
            text: 'Past President Ckeck 1 candidate',
            alignment: 'left',
            fontSize: 9,
            bold: true,
            margin: [ 0, 11, 0, 0 ]
          }
          docDefinition.content.push(titlepastpres)

          for (let k in pastpres) {
            let name = { columns: [ { image: 'data:image/jpeg;base64,' + this.box, width: 12 }, { text: pastpres[k].name, fontSize: 9, alignment: 'left', margin: [ 20, 0, 0, 0 ] } ], margin: [ 0, 7, 0, 0 ] }
            docDefinition.content.push(name)
          }
        }
        console.log(docDefinition)

        pdfMake.createPdf(docDefinition).download('Ballot.pdf')

        this.getVoters(this.electionId)
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async printFinal () {
      try {
        const response = await Api().get('elections/' + this.electionId)

        const electionName = response.data.name
        const numberDirectors = response.data.numberDirectors
        const numberExecs = response.data.numberExecs
        const candidateList = this.candidateList
        const director = []
        const execComm = []
        const secvp = []
        const treasurer = []
        const secretary = []
        const pastPres = []

        for (let i = 0; i < candidateList.length; i++) {
          console.log(candidateList[i])

          if (candidateList[i].position === 'Director') {
            director.push(candidateList[i])
          }

          if (candidateList[i].position === 'Exec Committee') {
            execComm.push(candidateList[i])
          }
          if (candidateList[i].position === '2nd Vice President') {
            secvp.push(candidateList[i])
          }
          if (candidateList[i].position === 'Treasurer') {
            treasurer.push(candidateList[i])
          }
          if (candidateList[i].position === 'Secretary') {
            secretary.push(candidateList[i])
          }
          if (candidateList[i].position === 'Past President') {
            pastPres.push(candidateList[i])
          }
        }

        let docDefinition = {
          // footer: function (currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount },
          content: [
            {
              image: 'data:image/jpeg;base64,' + this.logo,
              width: 100,
              alignment: 'center'
            },

            { text: electionName + ' Election', style: 'header' }
          ],

          styles: {
            header: {
              fontSize: 14,
              bold: true,
              alignment: 'center',
              margin: [ 0, 10, 0, 0 ]
            }
          }
        }

        let titleDir = {
          text: 'DIRECTOR ' + numberDirectors + ' position(s)',
          alignment: 'left',
          bold: true,
          margin: [ 0, 10, 0, 0 ]
        }
        docDefinition.content.push(titleDir)

        for (let j in director) {
          let name = { text: director[j].name + ' - ' + director[j].total, fontSize: 10, alignment: 'center', margin: [ 0, 10, 0, 0 ] }
          docDefinition.content.push(name)
        }

        let titleExec = {
          text: 'EXEC COMMITTEE ' + numberExecs + ' position(s)',
          alignment: 'left',
          bold: true,
          margin: [ 0, 10, 0, 0 ]
        }
        docDefinition.content.push(titleExec)

        for (let k in execComm) {
          let name = { text: execComm[k].name + ' - ' + execComm[k].total, fontSize: 10, alignment: 'center', margin: [ 0, 10, 0, 0 ] }
          docDefinition.content.push(name)
        }
        let titlesecVp = {
          text: '2nd Vice President',
          alignment: 'left',
          bold: true,
          margin: [ 0, 10, 0, 0 ]
        }
        docDefinition.content.push(titlesecVp)

        for (let k in secvp) {
          let name = { text: secvp[k].name + ' - ' + secvp[k].total, fontSize: 10, alignment: 'center', margin: [ 0, 10, 0, 0 ] }
          docDefinition.content.push(name)
        }

        let titleTreasurer = {
          text: 'Treasurer',
          alignment: 'left',
          bold: true,
          margin: [ 0, 10, 0, 0 ]
        }
        docDefinition.content.push(titleTreasurer)

        for (let k in treasurer) {
          let name = { text: treasurer[k].name + ' - ' + treasurer[k].total, fontSize: 10, alignment: 'center', margin: [ 0, 10, 0, 0 ] }
          docDefinition.content.push(name)
        }

        let titleSecretary = {
          text: 'Secretary',
          alignment: 'left',
          bold: true,
          margin: [ 0, 10, 0, 0 ]
        }
        docDefinition.content.push(titleSecretary)

        for (let k in secretary) {
          let name = { text: secretary[k].name + ' - ' + secretary[k].total, fontSize: 10, alignment: 'center', margin: [ 0, 10, 0, 0 ] }
          docDefinition.content.push(name)
        }

        let titlePastPres = {
          text: 'Past President',
          alignment: 'left',
          bold: true,
          margin: [ 0, 10, 0, 0 ]
        }
        docDefinition.content.push(titlePastPres)

        for (let k in pastPres) {
          let name = { text: pastPres[k].name + ' - ' + pastPres[k].total, fontSize: 10, alignment: 'center', margin: [ 0, 10, 0, 0 ] }
          docDefinition.content.push(name)
        }

        let sign = { text: 'Witness', alignment: 'left', bold: true, margin: [ 0, 10, 0, 10 ] }
        docDefinition.content.push(sign)

        pdfMake.createPdf(docDefinition).download('voteFinal.pdf')
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Elections.vue